import { Group } from './Group';

export class ACLChecker {
  constructor(groups, userIds) {
    this.groups = groups;
    this.userIds = userIds;
  }

  static async init(organizationId, acl) {
    const groups = [];
    const userIds = [];

    const promises = acl.map(async (accessor) => {
      if (accessor.entityType === 'Group') {
        const group = await Group.init(organizationId, accessor.entityId);
        groups.push(group);
      } else if (accessor.entityType === 'User') {
        userIds.push(accessor.entityId);
      }
    });

    await Promise.all(promises);

    return new ACLChecker(groups, userIds);
  }

  userHasAccess(userId) {
    let access = this.userIds.includes(userId);
    if (access) return access;

    this.groups.forEach(group => {
      if (access) return;

      if (group.hasUser(userId)) {
        access = true;
      }
    });

    return access;
  }

  groupHasAccess(groupId) {
    let access = false;

    this.groups.forEach(group => {
      if (access) return;

      if (group.groupId === groupId) {
        access = true;
      }
    });

    return access;
  }
}
